import React, { FC } from "react";
import { SelectBox } from "@ldp-web/component-library/ui/molecules/form/selectbox";
import { useSimpleTranslation } from "@ldp/simple-i18n";
import { useSortTracking } from "@ldp/sdm-analytics-utils";
import { useUpdateFilterQueryParams } from "../../hooks";
import { handleSortSelect, useRedirectLink } from "../../utils";
import { useSDMRouterContext } from "@ldp/sdm-contexts";

/** props for Sort component */
export type Options = {
  /** code for the key */
  code: string;
  /** Name of the Element */
  name: string;
  /** current selection */
  selected: boolean;
};

export const Layout = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
} as const;

export type SelectBoxComponentProps = {
  sorts: Options[];
  label: string;
  menuName: string;
  labelPosition?: (typeof Layout)[keyof typeof Layout];
  labelId: string;
};

export const SortComponent: FC<SelectBoxComponentProps> = (props) => {
  const i18n = useSimpleTranslation();
  const trackSortFn = useSortTracking();
  const router = useSDMRouterContext();
  const redirectToPage = useRedirectLink(router);
  const updateFilterQueryParams = useUpdateFilterQueryParams();
  if (props.sorts.length === 0) return null;
  /**
   * Function to handle sort click
   * @param sortType selected value of sort
   * updates query parameter and selected sort value, makes api call
   */
  const handleSortClick = (sortType: string) => {
    const queryParam = handleSortSelect(sortType, props.sorts);
    /** to track analytics */
    trackSortFn({
      sortEventValue: sortType,
    });
    const updatedUrl = updateFilterQueryParams(queryParam, true);
    redirectToPage(updatedUrl);
  };

  return (
    <SelectBox
      label={i18n("sortBy")}
      labelId="sort-by"
      menuName="menu-button-:r1:"
      labelPosition="horizontal"
      options={props.sorts}
      onSelected={handleSortClick}
      data-testid="selectbox"
    />
  );
};

export default SortComponent;
